<template>
  <AppActionButton
    v-if="features.featureAuthZ"
    data-locator="user-dialog-button"
    :icon="User"
    size="icon"
    @click="openUserDialog"
    :tooltip="$t('views.dialog.user.title')"
  />
</template>

<script lang="ts" setup>
const { features } = useFeatureFlagsStore();
const uiStore = useUiStore();
import { User } from 'lucide-vue-next';

function openUserDialog() {
  uiStore.userDialogVisible = true;
}
</script>
